import { NgModule } from '@angular/core';
import { XSi18nService } from '@nx-fe/services';
import { PipesModule, XsI18nPipe } from '@nx-fe/pipes';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { SSPHeaderComponent } from './components/header/ssp-header.component';
import { PageLayoutComponent } from './components/pagelayout/pagelayout.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    SSPHeaderComponent,
    PageLayoutComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    TranslateModule,
    BrowserModule,
    RouterModule
  ],
  providers: [
    XSi18nService,
    XsI18nPipe
  ],
  bootstrap: []
})
export class BasePageModule {
}
